import { FC } from 'react';
import styled from 'styles/styled-components';

import { essentialJourney1, essentialJourney2, essentialJourney3, essentialJourney4 } from '../Images';

import SVGIcon from 'components/SVGIcon/SVGIcon';
import { FormattedMessage } from 'react-intl';
import { RouteComponentProps, RouteProps, withRouter } from 'react-router-dom';
import { commonDimensions } from 'utils/constants';
import { arrowRightButton } from '../../FarmToTablePage/Images';
import messages from '../messages';
import { MainButton } from './CommonComponents';
import { SectionTitle, SectionTitleBox } from './ProductsSource';

const Container = styled.div`
  background: #ffffff;
`;

const SectionWrapper = styled.div`
  max-width: ${commonDimensions.MAX_WIDTH_CONTAINER}px;
  width: 100%;
  margin: 0 auto;
  padding: 40px 16px;
  @media (max-width: 1023px) {
    padding: 24px 16px;
  }
`;

const VideoContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 919px;
  margin: 0 auto;
  justify-content: center;
  gap: 36px;
  overflow-x: auto;
  @media (max-width: 1023px) {
    justify-content: normal;
    gap: 12px;
  }
`;

const VideoItem = styled.div`
  cursor: pointer;
`;

const VideoItemImage = styled.div`
  position: relative;
  background-image: ${({ img }) => `url(${img})`};
  padding-top: 180%;
  width: 200px;
  background-size: contain;
  background-repeat: no-repeat;
  @media (max-width: 1023px) {
    width: 125px;
    padding-top: 176%;
  }
`;

const PlayButton = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  width: 40px;
  height: 40px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: rgba(47, 56, 44, 0.25);
  box-shadow: -0.183px 0.183px 0.183px -0.365px rgba(255, 255, 255, 0.35) inset;
  backdrop-filter: blur(2.5px);
  @media (max-width: 1023px) {
    width: 25px;
    height: 25px;
  }
  & > div {
    position: relative;
    left: 1px;
    top: 1px;
  }
`;

const MainButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
  ${MainButton} {
    box-shadow: none;
    @media (max-width: 767px) {
      font-size: 16px;
    }
  }
  @media (max-width: 767px) {
    margin-top: 24px;
  }
`;

const VideoItems = [
  {
    id: 1,
    img: essentialJourney1,
    url: '',
  },
  {
    id: 2,
    img: essentialJourney2,
    url: '',
  },
  {
    id: 3,
    img: essentialJourney3,
    url: '',
  },
  {
    id: 4,
    img: essentialJourney4,
    url: '',
  },
];

const FreshJourney: FC<RouteProps & RouteComponentProps> = ({ history }) => {
  const lang = localStorage.getItem('lang') || 'vi';
  const loggedIn = !!localStorage.getItem('token');
  return (
    <Container>
      <SectionWrapper>
        <SectionTitleBox>
          {lang === 'vi' ? (
            <>
              <SectionTitle highLight>
                Hành trình sản phẩm<SectionTitle>&nbsp;tại Kamereo</SectionTitle>
              </SectionTitle>
            </>
          ) : (
            <>
              <SectionTitle highLight>
                The Product Journey
                <SectionTitle>&nbsp;at Kamereo</SectionTitle>
              </SectionTitle>
            </>
          )}
        </SectionTitleBox>
        <VideoContainer>
          {VideoItems?.map((item) => (
            <VideoItem key={item.id}>
              <VideoItemImage img={item.img}>
                {/* <PlayButton>
                  <SVGIcon src={PlayVideoImage} />
                </PlayButton> */}
              </VideoItemImage>
            </VideoItem>
          ))}
        </VideoContainer>
        {!loggedIn && (
          <MainButtonWrapper>
            <MainButton type="primary" style={{ background: '#43A047' }} onClick={() => history.push('/contact-us')}>
              <FormattedMessage {...messages.createPurchaseAccount} />
              <SVGIcon src={arrowRightButton} />
            </MainButton>
          </MainButtonWrapper>
        )}
      </SectionWrapper>
    </Container>
  );
};

export default withRouter(FreshJourney);
